import Vue from 'vue'
import {
  GET_PROJECT,
  GET_PROJECTS,
  ERROR_XHR,
  DELETE_PROJECT,
  SUCCESS_XHR,
  ADD_PROJECT,
  UPDATE_PROJECT,
  REQUEST_ADD_PROJECT,
  REQUEST_UPDATE_PROJECT
} from '../mutation-types.js'

// TODO use 'project' as a Vue resource
// TODO dispatch instantly, don't wait for server response, rollback if XHR_ERROR

/**
 *
 * @param dispatch
 * @returns {Promise}
 */
export const getProjects = ({ dispatch }) => {
  return new Promise((resolve, reject) => {
    Vue.http
      .get('projectList')
      .then(
        (response) => {
          dispatch(GET_PROJECTS, response.json())
          resolve()
        },
        (response) => {
          dispatch(ERROR_XHR, response.json())
          reject()
        })
  })
}

/**
 * Get single project
 *
 * @param store
 * @param projectId
 * @returns {Promise}
 */
/*
export const getProject = (store, projectId) => {
  const sortProjects = (projects, projectId) => projects.filter((project) => Number(project.id) === Number(projectId))[0]
  // If projects all is empty, launch getProjects action first
  if (!store.state.projects.all.length) {
    return getProjects(store).then(() => store.dispatch(GET_PROJECT, sortProjects(store.state.projects.all, projectId)))
  }
  return new Promise((resolve, reject) => {
    store.dispatch(GET_PROJECT, sortProjects(store.state.projects.all, projectId))
    resolve()
  })
}
*/
export const getProject = (store, projectId) => {
  return new Promise((resolve, reject) => {
    Vue.http
        .get('projectById/' + projectId)
        .then(
            (response) => {
              store.dispatch(GET_PROJECT, response.json())
              resolve()
            },
            (response) => {
              store.dispatch(ERROR_XHR, response.json())
              reject()
            })
  })
}

/**
 * Add a new project
 *
 * @param dispatch
 * @param project
 */
export const addProject = ({ dispatch }, project) => {
  dispatch(REQUEST_ADD_PROJECT)
  Vue.http
    .post('project', project)
    .then((response) => {
      /* let data = JSON.parse(response.data)
      dispatch(ADD_PROJECT, data.project) */
      dispatch(ADD_PROJECT, project)
    },
      (response) => {
        dispatch(ERROR_XHR, response.json())
      })
}

/**
 * Edit a project
 *
 * @param dispatch
 * @param oldProject The former project data
 * @param newProject The new project data
 */
export const editProject = ({ dispatch }, oldProject, newProject) => {
  dispatch(REQUEST_UPDATE_PROJECT)
  Vue.http
    .put('project/' + newProject.id, newProject)
    .then(
      (response) => {
        dispatch(UPDATE_PROJECT, oldProject, newProject)
      },
      (response) => {
        dispatch(ERROR_XHR, response.json())
      }
    )
}

/**
 * Delete a project
 *
 * @param dispatch
 * @param project
 */
export const deleteProject = ({ dispatch }, project) => {
  dispatch(DELETE_PROJECT, project)
  Vue.http.delete('project/' + project.id)
    .then(
      (response) => {
        dispatch(SUCCESS_XHR, project)
      },
      (response) => {
        dispatch(ERROR_XHR, response.json())
      }
    )
}



// WEBPACK FOOTER //
// ./src/vuex/actions/projectActions.js